import React from 'react';
import { Box, BoxProps, Typography } from '@mui/material';
import ILogo from 'assets/images/logo.png';
interface Props extends BoxProps { }

const Logo: React.FC<Props> = (props: Props) => {
    return (
        <Box {...props} component={'img'} src={ILogo}
            sx={{ width: 200, height: 70, pt: 2 }} />

       
    );
}

export default Logo;